module.exports = __webpack_public_path__ + "static/media/Detail_Icon_03_hovered.6ee5850c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Detail_Icon_03_hovered.png
// module id = 1578
// module chunks = 0